import { configureStore } from '@reduxjs/toolkit';

// Slices se agregan en subissues posteriores (#602 billing, #604 alta línea).
export const store = configureStore({
  reducer: {},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
